import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditBankingDetailsViewModel } from 'src/app/models/audit-bank-details-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-bank-details',
  templateUrl: './audit-bank-details.component.html',
  styleUrls: ['./audit-bank-details.component.scss']
})
export class AuditBankDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public bankDetails: AuditBankingDetailsViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.bankDetails = await this._auditService.GetBankingDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.bankDetails, 'MerchantAuditTrail_Banking_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
